import React from "react";
import { colors } from "../../constants/theme";

interface CardProps {
  header?: React.ReactNode;
  style?: React.CSSProperties;
  children: React.ReactNode;
}

export const Card: React.FC<CardProps> = ({ header, style, children }) => (
  <section style={{ display: "flex", flexDirection: "column", background: colors.card, border: `1px solid ${colors.border}`, borderRadius: 12, overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", height: "100%", ...style }}>
    {header && (
      <div style={{ padding: 12, display: "flex", alignItems: "center", gap: 8, borderBottom: `1px solid ${colors.border}`, background: "#f9f9f9", flexShrink: 0 }}>
        {header}
      </div>
    )}
    <div style={{ padding: 12, flex: 1, overflow: "auto", minHeight: 0 }}>{children}</div>
  </section>
);

